import { useEffect, useState } from "react";
import { useModal, useNFTContext } from "../../../../utils/ModalContext";

import CountdownTimer from "react-component-countdown-timer";

import Button from "../../../../common/button";
import Particle from "../../../../common/particle/v2";

import bannerThumb1 from "../../../../assets/images/octopuses/card-center.png";
import bannerThumb2 from "../../../../assets/images/octopuses/card-rigt.png";
import bannerThumb3 from "../../../../assets/images/octopuses/card-left.png";

import BannerStyleWrapper from "./Banner.style";
// import { getTotalMint } from "../../../../controllers/mint";
import abi from "../../../../controllers/abi.json";
import { useMoralis, useMoralisWeb3Api, useWeb3Contract, useNativeBalance } from "react-moralis";
import {  getSalePriceByCount, getStartAndEndDate, init, isPresaleOpen, setSaleDate } from "../../../../controllers/mint";
import { AiFillPropertySafety } from "react-icons/ai";

const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;
// const contractAddress = "0xdACAb45f4F76176C8ce69c25Ed6a494517062A48";

const Banner = () => {

  const {Moralis, isWeb3Enabled, enableWeb3, isAuthenticated} = useMoralis();
  const {saleStart,presaleStart, isPresaleOpen, isPaused, salePrice,count, countHandle, salePriceETH, presalePriceETH, maxReserved, maxPublic, maxPrivate, maxElements, totalMint} = useNFTContext();

  const { mintModalHandle, OopsModalHandle, walletModalHandle } = useModal();

  const max = isPresaleOpen ? maxPrivate : maxPublic;
  const price = isPresaleOpen ? presalePriceETH : salePriceETH;



  const clickHandle = async() => {
    if(isAuthenticated){
      mintModalHandle();
    }else{
      walletModalHandle();
    }
  }
  
  const isSaleStarted = new Date(saleStart*1000) < Date.now() ? true : false;

  const setSaleTime = async () => {
    // const time = new Date("2022-08-11 00:00:00");
    // let timeInSec = Math.floor(time.getTime() / 1000);
    await setSaleDate(1662912600);

  }

  // console.log('saleStart', isSaleStarted, isPresaleOpen);
  const settings = {
    count:isPresaleOpen ? Math.floor(saleStart- Date.now()/1000) : Math.floor((saleStart+259200)- Date.now()/1000),
    showTitle: true, 
    labelSize: 14,
    backgroundColor: "transparent",
    color: "#fff",
    dayTitle: "",
    hourTitle: "",
    minuteTitle: "",
    secondTitle: "", 
    id: "countdownwrap",
  };
  return (
    <BannerStyleWrapper className="bithu_v3_baner_sect" id="home">
      <div className="container">
        <div className="row">
          
        </div>
        <div className="row align-items-center">

          <div className="col-lg-6">
            <div className="banner-image-area3">
              {/* particles component */}
              <Particle />
              <img
                className="banner-image banner-image1"
                src={bannerThumb1}
                alt="ALPHA OCTOPUS banner thumb"
                style={{height: "500px"}}
              />
              <img
                className="banner-image banner-image2"
                src={bannerThumb2}
                alt="ALPHA OCTOPUS banner thumb"
                style={{height: "300px"}}
              />
              <img
                className="banner-image banner-image3"
                src={bannerThumb3}
                alt="ALPHA OCTOPUS banner thumb"
                style={{height: "300px"}}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="banner-conent3">
              <h4 className="banner-subtitle text-uppercase">
                Whitelist : <span className="red-color">{isPresaleOpen ? `Only ${111-totalMint} are remaining` : "Soldout"}</span>
              </h4>
              <h4 className="banner-subtitle text-uppercase">
                Total Minted : <span className="red-color">{totalMint + maxReserved}/{maxElements}</span>
              </h4>
              <h1 className="banner-title text-uppercase">{isPresaleOpen ? `Presale is Live Now` : isSaleStarted ?`MINT is Live Now`: `Presale Will Be Starting Soon`}</h1>
              <div className="bithu_v3_timer">
                <h5 className="text-uppercase"> {isPresaleOpen ?`Private Mint`:`Public Mint`} ends in</h5>
                <div className="timer timer_1">
                  <CountdownTimer {...settings} />
                </div>
              </div>
              <div className="banner-count-inner d-flex align-items-center">
                <div className="banner-btn-area">
                  <span
                    className="input-number-decrement"
                    onClick={() => (count > 1 ? countHandle(count - 1) : count)}
                    >
                    –
                  </span>
                  <input
                    className="input-number"
                    type="text"
                    value={count}
                    onChange={(e) => countHandle(e.target.value)}
                    max={max}
                    min={1}
                    />
                  <span
                    className="input-number-increment"
                    onClick={() => (count < max ? countHandle(count + 1) : alert(`you can't mint more than ${max} in ${isPresaleOpen?'Private':'Public'} Mint`)) }
                    >
                    +
                  </span>
                </div>
                <div className="bithu_v3_baner_buttons">
                  <Button lg variant="mint" onClick={() => clickHandle()}>
                    Mint Now
                  </Button>
                </div>
              </div>
                {/* <div className="bithu_v3_baner_buttons">
                  <Button lg variant="mint" onClick={async() => setSaleTime()}>
                    Set Sale date
                  </Button>
                </div> */}
              <div className="banner-bottom-text text-uppercase">
                {isPresaleOpen?'Private':'Public'} Mint {price}Eth + Gas 
                {/* Floor Price 2.08 Eth */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </BannerStyleWrapper>
  );
};

export default Banner;
